/**
 * @generated SignedSource<<b5c325dfece5c97339270090d8eb652a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HolidaysTimeOffBulkDeleteInput = {
  people_ids: ReadonlyArray<number | null | undefined>;
};
export type HolidaysTimeOffBulkDeleteMutation$variables = {
  input: HolidaysTimeOffBulkDeleteInput;
};
export type HolidaysTimeOffBulkDeleteMutation$data = {
  readonly action_holidays_time_off_bulk_delete: {
    readonly account: {
      readonly id: number;
    } | null | undefined;
  } | null | undefined;
};
export type HolidaysTimeOffBulkDeleteMutation = {
  response: HolidaysTimeOffBulkDeleteMutation$data;
  variables: HolidaysTimeOffBulkDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HolidaysTimeOffBulkDeleteOutput",
    "kind": "LinkedField",
    "name": "action_holidays_time_off_bulk_delete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HolidaysTimeOffBulkDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HolidaysTimeOffBulkDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fae869611c6d4a03ef0fbca6bc0c1e26",
    "id": null,
    "metadata": {},
    "name": "HolidaysTimeOffBulkDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation HolidaysTimeOffBulkDeleteMutation(\n  $input: HolidaysTimeOffBulkDeleteInput!\n) {\n  action_holidays_time_off_bulk_delete(input: $input) {\n    account {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ca856b30f86150c964b7cabeebb8e92";

export default node;
